export default (duration, t) => {
  switch (duration) {
    case 1:
      return `24 ${t('common:hours-subscription')}`
    case 3:
      return `72 ${t('common:hours-subscription')}`
    case 365:
      return `1 ${t('common:year-subscription')}`
    default:
      return `${duration} ${t('common:days-subscription')}`
  }
}




// WEBPACK FOOTER //
// ./utils/parseDurationTime.js